/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createErrorResponseFromDiscriminatorValue, createInternalErrorResponseFromDiscriminatorValue, createOpenPipelineFromDiscriminatorValue, type ErrorResponse, type InternalErrorResponse, type OpenPipeline } from '../../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/analytics/pipeline
 */
export interface PipelineRequestBuilder extends BaseRequestBuilder<PipelineRequestBuilder> {
    /**
     * Open money by stage, right now, always as five stages in order: OpenCarts (carts that belong to a customer; a rep's anonymous scratch cart is left out), Submitted, Processing and ShippedNotInvoiced (orders from the last year that no live invoice covers yet, placed by reading their status), and InvoicedUnpaid (issued and part-paid invoices with a balance). Order statuses are the organization's own words, so the stage is read from them: the organization's first status always means Submitted, cancelled and completed-style statuses are left out, shipping words mean shipped. Each order stage lists the statuses it counted. The overdue figures are the part of InvoicedUnpaid past its due date. Figures may be up to a few minutes old.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<OpenPipeline>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     get(requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<OpenPipeline | undefined>;
    /**
     * Open money by stage, right now, always as five stages in order: OpenCarts (carts that belong to a customer; a rep's anonymous scratch cart is left out), Submitted, Processing and ShippedNotInvoiced (orders from the last year that no live invoice covers yet, placed by reading their status), and InvoicedUnpaid (issued and part-paid invoices with a balance). Order statuses are the organization's own words, so the stage is read from them: the organization's first status always means Submitted, cancelled and completed-style statuses are left out, shipping words mean shipped. Each order stage lists the statuses it counted. The overdue figures are the part of InvoicedUnpaid past its due date. Figures may be up to a few minutes old.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const PipelineRequestBuilderUriTemplate = "{+baseurl}/api/analytics/pipeline";
/**
 * Metadata for all the requests in the request builder.
 */
export const PipelineRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: PipelineRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createOpenPipelineFromDiscriminatorValue,
    },
};
/* tslint:enable */
/* eslint-enable */
